import { apiCall } from './gqlClient';

const GETBODYMEASUREMENTS_QUERY = `
  query getBodyMeasurements($userId: Int!) {
    getBodyMeasurements(userId: $userId)
    {
      id
			userId
			leanMass
			boneMass
			visceralFat
			leftBiceps
			rightBiceps
			chest
			waist
			hips
			leftLeg
			rightLeg
			leftCalf
			rightCalf
			height
			weight
			dateCreated
      ...fragments
    }
  }`;

export const getBodyMeasurementsApiCall = async ({userId}, fragments = null) => apiCall({ query: GETBODYMEASUREMENTS_QUERY, variables: {userId}, fragments });
